"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserFeed = loadUserFeed;
exports.watchUserFeed = watchUserFeed;
exports["default"] = exports.feedSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _effects = require("redux-saga/effects");

var _utils = require("../../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _selectors = require("./selectors");

var _marked = _regeneratorRuntime2.mark(loadUserFeed),
    _marked2 = _regeneratorRuntime2.mark(watchUserFeed);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function loadUserFeed(api, action) {
  var _action$payload, userId, clientId, nextRequest, apiVersion, _yield$api$getFeedByU, fullResponse, userFeedData, prevData, nextData;

  return _regenerator["default"].wrap(function loadUserFeed$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, userId = _action$payload.userId, clientId = _action$payload.clientId, nextRequest = _action$payload.next, apiVersion = _action$payload.apiVersion;
          _context.next = 4;
          return api.getFeedByUserId({
            userId: userId,
            clientId: clientId,
            next: nextRequest,
            apiVersion: apiVersion
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getFeedByU = _context.sent;
          fullResponse = _yield$api$getFeedByU.data;
          _context.next = 8;
          return (0, _effects.select)(_selectors.userFeedDataSelector);

        case 8:
          userFeedData = _context.sent;
          prevData = userFeedData || [];
          nextData = fullResponse.data || [];
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserFeedSuccess(_objectSpread({}, fullResponse, {
            data: [].concat((0, _toConsumableArray2["default"])(prevData), (0, _toConsumableArray2["default"])(nextData))
          })));

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](0);
          _context.next = 19;
          return (0, _effects.put)(_actions["default"].loadUserFeedError(true));

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 15]]);
}

function watchUserFeed(api) {
  return _regenerator["default"].wrap(function watchUserFeed$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserFeed), loadUserFeed, api);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var feedSagas = function feedSagas(api) {
  return [(0, _effects.fork)(watchUserFeed, api)];
};

exports.feedSagas = feedSagas;
var _default = feedSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map